interface Props {
  current: number; // 1-based
  total: number;
}

export function StepProgress({ current, total }: Props) {
  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center justify-between text-xs uppercase tracking-[0.3em] text-cream-dim">
        <span>
          Step {current} of {total}
        </span>
      </div>
      <div className="flex gap-1.5">
        {Array.from({ length: total }, (_, i) => i + 1).map((n) => {
          const reached = n <= current;
          return (
            <div
              key={`step-${n}`}
              className={`h-1 flex-1 rounded-full transition-colors ${
                reached ? "bg-amber" : "bg-cream/15"
              }`}
            />
          );
        })}
      </div>
    </div>
  );
}
